import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { get } from 'lodash';
import { SmoothLink } from '@bd/bdcore-utilities';
import { css } from '@bd/bdui-styles/emotion';
import { colors } from '../../styles';

const styles = css`
display: none;
@media (min-width: 768px) {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -70px;
  height: 64px;
  border-bottom: 1px solid #EBEBEB;
  background: rgba(0,0,0,0.50);
  position: relative;
  z-index: 10;
}
@media (min-width: 992px) {
  height: 70px;
}
  .CommunityDetailMenu_link {
    font-size: 13px;
    font-weight: bold;
    letter-spacing: 0.142857em;
    line-height: 1;
    text-transform: uppercase;
    color: white;
    display: block;
    padding: 3px 14px 0;
    height: 100%;
    &:hover {
      text-decoration: none;
    }
    @media (min-width: 992px) {
      font-size: 14px;
      padding: 4px 21px 0;
    }
  }
  .CommunityDetailMenu_linkText {
    display: inline-flex;
    align-items: center;
    height: 100%;
    border-bottom: 4px solid transparent;
    @media (min-width: 992px) {
      border-bottom-width: 6px;
    }
  }
  &.CommunityDetailMenu-defaultActive .CommunityDetailMenu_link:first-child .CommunityDetailMenu_linkText,
  .CommunityDetailMenu_link.active .CommunityDetailMenu_linkText {
    border-bottom-color: ${colors.color6};
  }
`;

function CommunityDetailMenu({ router, hideHomes }) {
  const links = [
    {
      text: 'Home Sites',
      hash: 'platMap',
    },
    {
      text: 'Available Homes',
      hash: 'available-homes',
      isHidden: hideHomes,
    },
    {
      text: 'Neighborhood Overview',
      hash: 'overview',
    },
    {
      text: 'Neighborhood Features',
      hash: 'features',
    },
    {
      text: 'Preferred Builders',
      hash: 'approved_builders',
    },
    {
      text: 'Partners',
      hash: 'partners',
    },
  ];

  const hash = get(router, 'location.hash');
  return (
    <div className={`${styles} ${!hash ? 'CommunityDetailMenu-defaultActive' : ''}`.trim()}>
      {
        links.filter(l => !l.isHidden).map(link => (
          <SmoothLink
            className="CommunityDetailMenu_link"
            href={`#${link.hash}`}
            key={link.hash}
          >
            <div
              className="CommunityDetailMenu_linkText"
              dangerouslySetInnerHTML={{ __html: link.text }}
            />
          </SmoothLink>
        ))
      }
    </div>
  );
}

CommunityDetailMenu.propTypes = {
  router: PropTypes.object.isRequired,
  hideHomes: PropTypes.bool,
};

CommunityDetailMenu.defaultProps = {
  hideHomes: false,
};

export default withData({
  router: true,
})(CommunityDetailMenu);



// WEBPACK FOOTER //
// ./src/pages/CommunityDetail/Menu.js